import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CipScreenShell, CipSpinner } from '../../components/smart/cip';
import { SmartShell } from '../../components/smart/SmartShell';
import { Button } from '../../components/smart/ui/Button';
import { SMART_ROUTES } from '../../constants';

/**
 * Gallery KYC gate screens (pre-CIP). Live `KycFlow` hits cip-readiness;
 * here each state is a static Control Dock entry.
 */

const KycShell = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('smart');
  return (
    <SmartShell
      title={t('wizard.headline.kyc.title')}
      subtitle={t('wizard.headline.kyc.subtitle')}
    >
      {children}
    </SmartShell>
  );
};

export const KycCheckingPage = () => {
  const { t } = useTranslation('smart');
  return (
    <KycShell>
      <CipScreenShell
        label={t('wizard.kyc.eyebrow')}
        title={t('wizard.kyc.checking.title')}
        description={t('wizard.kyc.checking.description')}
      >
        <div className="mt-8 flex justify-center">
          <CipSpinner className="h-8 w-8" />
        </div>
      </CipScreenShell>
    </KycShell>
  );
};

export const KycIntroPage = () => {
  const { t } = useTranslation('smart');
  const navigate = useNavigate();
  return (
    <KycShell>
      <CipScreenShell
        label={t('wizard.kyc.eyebrow')}
        title={t('wizard.kyc.intro.title')}
        description={t('wizard.kyc.intro.description')}
      >
        <div className="mt-6 grid grid-cols-1 gap-2">
          <Button
            fullWidth
            size="lg"
            onClick={() => navigate(SMART_ROUTES.CIP_CLAIMING)}
          >
            {t('wizard.kyc.intro.verifyCta')}
          </Button>
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            onClick={() => navigate(SMART_ROUTES.COLLECT_SUMMARY)}
          >
            {t('wizard.kyc.back')}
          </Button>
        </div>
      </CipScreenShell>
    </KycShell>
  );
};

export const KycErrorPage = () => {
  const { t } = useTranslation('smart');
  const navigate = useNavigate();
  return (
    <KycShell>
      <CipScreenShell
        label={t('wizard.kyc.eyebrow')}
        title={t('wizard.kyc.error.title')}
        description={t('wizard.kyc.error.description')}
      >
        <div className="mt-6 grid grid-cols-1 gap-2">
          <Button
            fullWidth
            size="lg"
            onClick={() => navigate(SMART_ROUTES.KYC_INTRO)}
          >
            {t('wizard.kyc.error.retryCta')}
          </Button>
        </div>
      </CipScreenShell>
    </KycShell>
  );
};
